import { render } from "./Pricing.vue?vue&type=template&id=11b9bcc4&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=11b9bcc4&scoped=true&lang=css"

import exportComponent from "/Users/am/Projects/jeet_edit/quiztest_edit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b9bcc4"]])

export default __exports__